import React from 'react';
import { useTranslation } from '@pascal/pascal-core';
import TabInfo from '../tabInfo';
import { TranslationKeys } from '../../core/constants/translationKeys';
import { TAB_INDEX_FOR_FAIRNESS } from '../../core/constants/gameConstants';

function FairnessTabRowInfo({ activeTabIndex, setActiveTabIndex }) {
  const t = useTranslation();
  return (
    <div className='keno-tab-row'>
      <TabInfo
        text={t(TranslationKeys.History)}
        index={TAB_INDEX_FOR_FAIRNESS.History}
        activeTabIndex={activeTabIndex}
        handleClick={setActiveTabIndex}
      />
      <TabInfo
        text={t(TranslationKeys.Fairness)}
        index={TAB_INDEX_FOR_FAIRNESS.Fairness}
        activeTabIndex={activeTabIndex}
        handleClick={setActiveTabIndex}
      />
    </div>
  );
}
export default FairnessTabRowInfo;
